/**
 * To display the model from the RN app we need the url to be absolute
 */
export const toAbsolutePath = (path: string): string => {
  // only check for http for now. All the models are currently stored in the project
  const isAbsolute = path.startsWith('http');
  if (isAbsolute) {
    return path;
  }
  const startsWithSlash = path.startsWith('/');
  const { origin } = window.location;

  if (startsWithSlash) {
    return origin + path;
  }
  return origin + '/' + path;
};
